import * as types from '@store/mutation-types'

// initial state
const state = {
  options: {},
}

// getters
const getters = {
  // workInfoCompanyTable: state => state.table
}

// actions
const actions = {
  workInfoCompanyQuery: ({commit, state}, params) => request.alert('workInfoCompanyQuery', params),
  workInfoCompanyCreate: ({commit, state}, params) => request.alert('workInfoCompanyCreate', params),
  workInfoCompanyEdit: ({commit, state}, params) => request.alert('workInfoCompanyEdit', params),
  workInfoCompanyGet: ({commit, state}, params) => request.alert('workInfoCompanyGet', params),
  workInfoCompanyDelete: ({commit, state}, params) => request.alert('workInfoCompanyDelete', params),
}

// mutations
const mutations = {
  [types.SET_USER_OPTIONS] (state, data) {
    filter.setLoop(state.options, data)
  },
}

export const workInfoCompany = {
  state,
  getters,
  actions,
  mutations,
}




// WEBPACK FOOTER //
// ./src/views/work-info-company/work-info-company.store.js